module.exports = new __parcel__URL__("floor-tom_5.090c6c58.mp3").toString();